import {ComponentType} from 'react';
import loadable from '../../../../../utils/loadable';
import {RouteConfig} from '@deviceinsight/ng-ui-scale-lib/api';
import {AUTHORITY_CREATE_KPI_DATA_PROCESSING_DEFINITION} from '../../../../../modules/common/consts';

const AssetDpdContextProvider: ComponentType<unknown> = loadable({
	loader: () => import('../../../../../modules/dataprocessingdefinitions/AssetDataProcessingDefinitionPage')
});
export default {
	relativePath: 'create',
	component: AssetDpdContextProvider,
	requiredAuthorities: [AUTHORITY_CREATE_KPI_DATA_PROCESSING_DEFINITION]
} satisfies RouteConfig;
